import SearchSalesMainContent from './SearchSalesMainContent';
export default SearchSalesMainContent;
